import { defineSystem, getComponentValueStrict, Has, UpdateType } from "@latticexyz/recs";
import { Animations, OVERSIZED_ANIMATIONS } from "../../phaserConstants";
import { PhaserLayer } from "../../types";

/**
 * The Appearance system handles setting textures of phaser game objects based on their Appearance component
 */
export function createSpriteAnimationSystem(layer: PhaserLayer) {
  const {
    world,
    components: { SpriteAnimation },
    scenes: {
      Main: {
        objectPool,
        maps: {
          Main: { tileWidth },
        },
      },
    },
    parentLayers: {
      local: {
        components: { LocalPosition },
      },
    },
  } = layer;

  defineSystem(world, [Has(SpriteAnimation), Has(LocalPosition)], ({ entity, type }) => {
    if (type !== UpdateType.Enter) return;

    const embodiedEntity = objectPool.get(entity, "Sprite");

    const animation = getComponentValueStrict(SpriteAnimation, entity).value;
    embodiedEntity.setComponent({
      id: SpriteAnimation.id,
      once: (gameObject) => {
        gameObject.play(animation);

        if (OVERSIZED_ANIMATIONS.includes(animation as Animations)) {
          gameObject.setScale(tileWidth / gameObject.width);
        }

        const animationSize = gameObject.width * gameObject.scaleX;
        const newOrigin = (animationSize - tileWidth) / (2 * animationSize);
        gameObject.setOrigin(newOrigin);
      },
    });
  });
}
